export const legacyEquipmentPrompts = [
  {
    text: `I'm Searching for Equipment`,
    children: [
      {
        text: `Searching for New Equipment`,
        parentText: "I'm Searching for Equipment",
        url: 'https://www.legacyequipment.com/New-Equipment'
      },
      {
        text: `Looking for Used Equipment`,
        parentText: "I'm Searching for Equipment"
      },
      {
        text: `I Have a General Question `,
        parentText: "I'm Searching for Equipment"
      }
    ]
  },
  {
    text: `I'm Searching for Parts`,
    children: [
      {
        text: 'Shop Legacy Equipment Parts',
        parentText: "I'm Searching for Parts"
      }
    ]
  },
  {
    text: `My Machine Needs Service`,
    children: [
      {
        text: 'Schedule Equipment Service',
        parentText: 'My Machine Needs Service',
        url: 'https://www.legacyequipment.com/Service'
      }
    ]
  },
  {
    text: `Trade In`,
    children: [
      {
        text: `Get a Trade In Quote`,
        parentText: 'Trade In',
        url: 'https://www.legacyequipment.com/trade-in'
      }
    ]
  },
  {
    text: `Looking for a Rental`,
    children: [
      {
        text: 'Search Equipment Rentals ',
        parentText: 'Looking for a Rental'
      },
      {
        text: 'Attachments For Rent',
        parentText: 'Looking for a Rental'
      },
      {
        text: 'Request Rental Quote',
        parentText: 'Looking for a Rental'
      }
    ]
  },

  {
    text: `Quick Question`,
    children: [
      {
        text: 'Something Else',
        parentText: 'Quick Question'
      }
    ]
  }
]
